module.exports = __webpack_public_path__ + "img/Procu.51d6ae17.svg";